(function (angular, location, document) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyDeepAnchorLink", [
    "StickToTopManager",
    "$window",
    function (StickToTopManager, $window) {
      return {
        link: function (scope, element) {
          var fudge = 0.5; // fudge factor -- better to scroll down 1px further into a module than 1px short
          element.css("top", -StickToTopManager.getManagedElementsCombinedHeight() + fudge);

          var locationHashElementId = location.hash.replace("#", "");

          if (element.attr("id") === locationHashElementId) {
            $window.addEventListener("load", function () {
              var elScrollTo = document.getElementById(locationHashElementId);
              elScrollTo.scrollIntoView(true);
            });
          }
        },
      };
    },
  ]);
})(window.angular, window.location, window.document);
